import { CONFIG } from "./globalConfig"

const env = {}
const PROD = true
const URL = PROD ? CONFIG.DOMAIN : "http://localhost"
const PORT = CONFIG.APP_PORT || 1337
env.url = URL
env.port = PORT
env.parseServerUrl = `${URL}:${PORT}/parse`
env.slaveServerUrl = `${URL}:${SLAVE_PORT || 1448}/parse`
env.apiUrl = `${URL}:${PORT}/api/v1`
env.appId = CONFIG.PARSE_SERVER.P_APP_ID
env.masterKey = CONFIG.PARSE_SERVER.P_MASTER_KEY
env.javascriptKey = CONFIG.PARSE_SERVER.P_JS_KEY
env.appName = CONFIG.APP_NAME
env.version = CONFIG.VERSION
export default env
